import { render, staticRenderFns } from "./GradeTableRanges.vue?vue&type=template&id=e7fbf2c0&scoped=true"
import script from "./GradeTableRanges.vue?vue&type=script&lang=js"
export * from "./GradeTableRanges.vue?vue&type=script&lang=js"
import style0 from "./GradeTableRanges.vue?vue&type=style&index=0&id=e7fbf2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fbf2c0",
  null
  
)

export default component.exports